/**
 * Created on 9/15/21.
 */

/**
 * Changed this file from .js to .ts on 05/08/2024
 */

import * as AppRoutes from './app-routes';
import * as TransitionPresets from './transition-presets';

const WEB_NFC_PERMISSIONS_VIDEO = '/static/video/allow-webnfc-permissions.mp4';

export { AppRoutes, TransitionPresets, WEB_NFC_PERMISSIONS_VIDEO };
